define('vspot-angular/services/org-job-titles-service',[], function () {
    'use strict';

    return ['resources.OrgJobTitles', function (OrgJobTitles) {

        return {
            /*
             * Get a list of all the job types within a group
             * @param activityType {str} - The type of activity to return data for.
             * @param jobType {int} - The type of job to return data for.
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(activityType, jobType) {
                return OrgJobTitles.query({
                    activitytype:   activityType,
                    jobtype:        jobType
                });
            },
            save: function(postData) {
                return OrgJobTitles.save(postData);
            },
            update: function(postData) {
                return OrgJobTitles.update(postData);
            },
            delete: function(id) {
                return OrgJobTitles.delete({
                    id: id
                });
            }
        };
    }];
});

